<template>
  <div class="app-container">
    <CrudTable entity="PrinterClient" :columns="columns" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: ['name', { field: 'workshopName', label: 'common.workshop' }]
    };
  }
};
</script>

<style scoped></style>
